module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-radio-group', _vm._b({
    ref: "radioGroup",
    class: _vm.computedClass,
    attrs: {
      "disabled": _vm.computedDisabled,
      "border-size": _vm.borderSize,
      "button-size": _vm.buttonSize
    },
    on: {
      "change": _vm.handleChange,
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, 'el-radio-group', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e8a5ea8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/radio/rtRadioGroup.vue
// module id = 2175
// module chunks = 137